module.exports = __webpack_public_path__ + "img/cabbage-posterized-small-charlie.1030b950.png";